<div class="dasboard-width" >
  <div class="row header mar-lft-rgt-0">
    <div class="col-md-6">View Organisations</div>
    <div class="col-md-6">
      <ol class="breadcrumb cust-bread">
        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i
          class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Organisation</li>
      </ol>
    </div>
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <div class="col-md-3">
      <div class="views-title">
        Views
      </div>
      <div class="views-body">
        Folders
        <button class="btn btn-light" (click)="toggleViews()"><i class="fa " [ngClass]="displayed?'fa-minus':'fa-plus'"></i>
        </button>
      </div>
      <div class="views" [hidden]="!displayed" (click)="getOrganizations()">
        <i class="fa fa-inbox"></i>
        All Organizations
        <span class="badge badge-primary pull-right">{{totalData}}</span>
      </div>
    </div>
    <div class="col-md-9">
      <div class="card">
        <div class="card-header card-header-top">
          Organizations
          <div class="pull-right none font-13" [ngClass]="{'block':show}">(Selected items:<span>{{selected}}</span>)
          </div>
          <div class="pull-right font-13">
            <b>Total items: </b> <span>{{totalData}}</span>
          </div>

        </div>
        <div class="card-body card-body-grid" style="height: 486px">
          <angular-slickgrid gridId="grid1"
                             [columnDefinitions]="columnDefinitions"
                             [gridOptions]="gridOptions"
                             (onAngularGridCreated)="angularGridReady($event)"
                             (sgOnCellChange)="onCellChanged($event.detail.eventData, $event.detail.args)"
                             gridWidth="1000"
                             (sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"
                             [dataset]="dataset">
          </angular-slickgrid>
        </div>
      </div>

    </div>

  </div>
</div>
